import React, { useRef, useState } from "react";
import { DeleteRounded, ExpandMore, UploadRounded, VisibilityRounded} from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, Button, Grid, IconButton, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";
import { IClaimInsertionForm } from "../../models/models";
import Preview from "../../preview/Preview";

const ClaimAttachments = () => {
    const {t} = useTranslation(['network', 'translation']);
    const theme = useTheme();

    const claimInsertionForm = useFormContext<IClaimInsertionForm>();

    const [accordion, setAccordion] = useState(true);
    const [openPreviewAttach, setOpenPreviewAttach] = useState(false);
    const [filePreview, setFilePreview] = useState(null);
    const [list, setList] = useState<any[]>([]);
    const uploaderRef  = useRef(null);

    const files: any[] = claimInsertionForm.getValues('attachments.files');

    const handleUpload = (e: any) => {
        if (!!uploaderRef) {
            // @ts-ignore
            uploaderRef.current.click();
        }
    }

    const handleOnUpload = (e: any) => {
        e.stopPropagation();

        if (!!e.target.files[0]?.size) {
            let reader = new FileReader();
            reader.readAsDataURL(e.target.files[0]);
            reader.onload = function () {
                const listNew = list.concat([{name: e.target.files[0].name, file: reader.result}]);
                setList(listNew);
                claimInsertionForm.setValue('attachments.files', listNew);

                // @ts-ignore
                uploaderRef.current.value = '';
            };
        }
    }

    const handlePreview = (e: React.SyntheticEvent, index: number) => {
        e.stopPropagation();

        // @ts-ignore
        setFilePreview(list[index]);
        setOpenPreviewAttach(true);
    }

    const handleClosePreview = () => {
        setFilePreview(null);
        setOpenPreviewAttach(false);
    }

    const handleDeleteFile = (e: React.SyntheticEvent, index: number) => {
        e.stopPropagation();

        setList(list.splice(index, 1));
        claimInsertionForm.setValue('attachments.files', list);
    }

    const handleAccordionOnChange = (e: React.SyntheticEvent, expanded: boolean) => {
        e.stopPropagation();

        setAccordion(expanded);
    }

    return (
        <Accordion expanded={accordion} onChange={(e, expanded) => handleAccordionOnChange(e, expanded)}>
            <AccordionSummary expandIcon={<ExpandMore />}>
                <Typography variant={"h6"}>
                    {t("claimInsertion.attachments.accordion.title")}
                </Typography>
            </AccordionSummary>

            <AccordionDetails>
                <Grid container columnSpacing={2}>
                    <Grid item xs={12} sx={{mb: theme.spacing(2)}}>
                        <Button size={"icon"} onClick={handleUpload}>
                            <input hidden accept=".pdf,.png,.jpeg,.jpg'" multiple type="file" ref={uploaderRef}
                                   onChange={(event) => handleOnUpload(event)} />
                            <UploadRounded />
                        </Button>
                    </Grid>

                    {
                        !!files &&
                        files
                            .map((file: any, index: number) =>
                                <Grid item container xs={12} md={6} columnSpacing={2} sx={{mb: 'auto'}} key={"attch_" + index}>
                                    <Grid item xs={8} sx={{display: "flex", alignItems: "center"}}>
                                        {file.name}
                                    </Grid>

                                    <Grid item xs={4}>
                                        <IconButton color="secondary" onClick={(e: React.SyntheticEvent) => handlePreview(e, index)}
                                                    sx={{mx: theme.spacing(1)}}>
                                            <VisibilityRounded />
                                        </IconButton>
                                        <IconButton color="secondary" onClick={(e: React.SyntheticEvent) => handleDeleteFile(e, index)}
                                                    sx={{mx: theme.spacing(1)}}>
                                            <DeleteRounded/>
                                        </IconButton>
                                    </Grid>
                                </Grid>
                            )
                    }
                </Grid>

                {/* Preview*/}
                <Preview
                    open={openPreviewAttach}
                    attach={filePreview}
                    onClose={handleClosePreview}
                />
            </AccordionDetails>
        </Accordion>
    );

}

export default ClaimAttachments;